// extracted by mini-css-extract-plugin
export default {"theme":"ModalWithTheme_theme__RRqdF"};